"use client";
import { useState, useEffect } from "react"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Icons from "@src/components/Icons"
import CountdownSale from "@src/components/CountdownSale"
import { useLayoutContext } from "@src/layouts/provider"
import { useTranslation } from "react-i18next"

const TitleFlashSale = () => {
  const { t } = useTranslation()

  const { config } = useLayoutContext()
  const { flash_sale } = config || {}

  const [countdownSeconds, setCountdownSeconds] = useState(0)

  useEffect(() => {
    const { flash_sale } = config || {}
    if (flash_sale && flash_sale.id) {
      const { from, to } = flash_sale || {}
      const toTime = new Date(to).getTime()
      const now = new Date().getTime()
      if (now < toTime) {
        setCountdownSeconds((toTime - now) / 1000)
      }
    }
  }, [config])

  return (
    <Stack
      flexDirection={{ xs: "column", lg: "row" }}
      alignItems="center"
      justifyContent={{
        xs: "center",
        lg: "start"
      }}
      gap={{
        xs: 2,
        lg: 4
      }}
      my={2}
    >
      <Box sx={{
        scale: {
          xs: 0.8,
          lg: 1
        }
      }}>
        <Icons name="flash-sale" />
      </Box>
      {flash_sale?.isGoingOn && (
        <>
          {countdownSeconds > 0 && (
            <Typography
              display={{
                xs: "block",
                lg: "none"
              }}
              marginTop="-10px"
            >
              {t("flash_sale.ends_in")}
            </Typography>
          )}
          <CountdownSale remainSeconds={countdownSeconds} />
        </>
      )}

    </Stack>
  )
}

export default TitleFlashSale